import { useEffect, useState } from 'react';
import Title from '../../../componente/cadastro/titulo/index.jsx';
import Description from '../../../componente/cadastro/descricao/index.jsx';
import SearchField from '../../../componente/cadastro/busca/index.jsx';
import Table from '../../../componente/cadastro/tabela/index.jsx';
import Pagination from '../../../componente/cadastro/paginacao/index.jsx';
import Sidebar from "../../../componente/sidebar/index.jsx";
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from "../../context/AppContext.jsx";
import { toast } from 'react-hot-toast';
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import PopUp2 from "../../../componente/popup/index.jsx";
import DuasDatas from '../../../componente/cadastro/duasdatas/index.jsx';
import Aguarte from "../../../componente/aguarde/index.jsx";

Modal.setAppElement("#root");

const OpeRelacaoNota = () => {
    const [search, setSearch] = useState('');
    const getFirstDayOfMonth = () => {
        const dt = new Date();
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-01`;
    };

    // Função para calcular a data atual
    const getCurrentDate = () => {
        const dt = new Date();
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-${dt.getDate().toString().padStart(2, "0")}`;
    };

    const [dt1, setdt1] = useState(getFirstDayOfMonth);
    const [dt2, setdt2] = useState(getCurrentDate);

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        totalPages: 0
    });
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [error, setError] = useState(null);
    const { accessKey, codassinante, codempresa } = useAppContext(); // Acessa os dados do contexto          
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const columns = [
        { key: 'nnf', title: 'Nota' },
        { key: 'codpedido', title: 'Pedido' },
        { key: 'demi', title: 'Emissão', type: 'date' },
        { key: 'nome', title: 'Cliente' },
        { key: 'status', title: 'Situação' },
        { key: 'vnf', title: 'Valor', type: 'float' },
    ];

    const getMenuOptions = (status) => {
        switch (status) {
            case "Nota Digitada":
            case "Nota Gerada":
                return [
                    { label: "Consultar", onClick: (item) => ConsultarNfe(item) },
                    { label: "Gerar", onClick: (item) => GerarNfe(item) },
                    { label: "Cancelar", onClick: (item) => handleOpen(item) },
                    { label: "Inutilizar", onClick: (item) => handleInutilizarOpen(item) },
                ];

            case "Nota Transmitida":
                return [
                    { label: "Consultar", onClick: (item) => ConsultarNfe(item) },
                    { label: "Cancelar", onClick: (item) => handleOpen(item) },
                    { label: "Imprimir", onClick: (item) => ImprimirNfe(item) },
                    { label: "Baixar XML", onClick: (item) => BaixarXML(item) },
                ];

            case "Nota Cancelada":
                return [
                    { label: "Consultar", onClick: (item) => ConsultarNfe(item) },
                    { label: "Imprimir", onClick: (item) => ImprimirNfe(item) },
                    { label: "Baixar XML", onClick: (item) => BaixarXML(item) },
                ];

            default:
                return [{ label: "Consultar", onClick: (item) => ConsultarNfe(item) }];
        }
    };

    //campos
    const [codnota, setCodNota] = useState(0);
    const [correcao, setCorrecao] = useState("");

    const handleOpen = (cad) => {
        if (!verificarStatus4(cad)) return;

        setCodNota(cad.codnota);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        CancelarNfe();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleInutilizarOpen = (cad) => {
        if (!verificarStatus1(cad)) return;

        if (!verificarStatus2(cad)) return;

        if (!verificarStatus4(cad)) return;

        setCodNota(cad.codnota);
        setIsOpen2(true);
    };

    const handleInutilizarConfirma = () => {
        setIsOpen2(false);
        InutilizarNfe();
    };

    const handleInutilizarClose = () => {
        setIsOpen2(false);
    };

    const fetchData = async (searchTerm, page, limit) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("/v1/operacao/relacaonota", {
                params: {
                    busca: searchTerm,
                    page,
                    per_page: limit,
                    codassinante,
                    codempresa,
                    dt1,
                    dt2
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setData(response.data.data);
            setPagination({
                total: response.data.pagination.Total,
                totalPages: response.data.pagination.TotalPages
            });
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            fetchData(search, currentPage, perPage);
        }, 1000); // Aguarda 1 segundo após o usuário parar de digitar

        // Cleanup function para limpar o timeout anterior
        return () => clearTimeout(timeoutId);
    }, [search, currentPage, perPage, codempresa, dt1, dt2]);

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        setCurrentPage(1); // Volta para primeira página ao mudar quantidade
    };

    const verificarStatus1 = (item) => {
        if (item.status === "Nota Digitada") {
            alert("Não será processado porque a situação está como Pendente.");
            return false;
        }

        // Situação ok
        return true;
    };

    const verificarStatus2 = (item) => {
        if (item.status === "Nota Gerada") {
            alert("Não será processado porque a situação está como Pendente.");
            return false;
        }

        // Situação ok
        return true;
    };

    const verificarStatus4 = (item) => {
        if (item.status === "Nota Cancelada") {
            alert("Não será processado porque a situação está como Pendente.");
            return false;
        }

        // Situação ok
        return true;
    };

    const verificarCorrecao = () => {
        if (correcao === "") {
            alert("Não será processado porque a correção está em branco.");
            return false;
        }

        // Situação ok
        return true;
    };

    async function ConsultarNfe(item) {
        try {
            setLoading2(true);
            setError(null);

            if (codempresa === 0) {
                alert('Selecione a filial antes!');
                return; // <-- impede que continue para o POST
            }

            const response = await api.post("/v1/fiscal/consultarnota", {
                codempresa,
                codnota: item.codnota,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });

            toast.success('Consulta da Nota feito com Sucesso!');

            alert(response.data);
        } catch (error) {
            console.error('Erro ao consultar nota:', error);
            setError('Erro ao tentar consultar a nota. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }

    }

    async function GerarNfe(item) {
        try {
            setLoading2(true);
            setError(null);

            if (codempresa === 0) {
                alert('Selecione a filial antes!');
                return;
            }

            const response = await api.post(
                "/v1/fiscal/gerarnota",
                {
                    codempresa,
                    nnf: item.nnf,
                    codnota: item.codnota,
                    cliente: item.cliente,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey} `,
                    },
                    responseType: "arraybuffer",
                }
            );

            // =====================================================
            // SUCESSO - recebeu o PDF
            // =====================================================

            fetchData();

            toast.success('Nota gerada com Sucesso!');

            const blob = new Blob(
                [response.data],
                { type: "application/pdf" }
            );

            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.click();

            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Erro ao gerar nota:', error);

            let mensagem = 'Erro ao tentar gerar nota. Tente novamente.';

            // =====================================================
            // TENTA PEGAR A MENSAGEM ENVIADA PELA API
            // =====================================================

            if (error.response?.data) {
                try {
                    const decoder = new TextDecoder("utf-8");

                    const texto = decoder.decode(error.response.data);

                    console.log('Resposta da API:', texto);

                    const resposta = JSON.parse(texto);

                    if (resposta.mensagem) {
                        mensagem = resposta.mensagem;
                    }

                } catch (e) {
                    console.error('Erro ao interpretar resposta da API:', e);
                }
            }

            setError(mensagem);
            toast.error(mensagem);

        } finally {
            setLoading2(false);
        }
    }


    async function ImprimirNfe(item) {
        try {
            setLoading2(true);
            setError(null);

            const response = await api.post(
                `/v1/fiscal/imprimirnota`,
                {
                    codempresa,
                    codnota: item.codnota,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                    responseType: "arraybuffer", // 👈 fundamental
                }
            );

            toast.success("PDF da nota gerado com sucesso!");

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.click();
        } catch (error) {
            console.error("Erro ao tentar gerar PDF:", error);
            setError("Erro ao tentar gerar o PDF. Tente novamente.");
            toast.error("Ocorreu algum erro! ❌");
        } finally {
            setLoading2(false);
        }
    }

    async function BaixarXML(item) {
        try {
            setLoading2(true);
            setError(null);

            const response = await api.post(
                `/v1/fiscal/baixarxml`,
                {
                    codempresa,
                    codnota: item.codnota,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                    responseType: "arraybuffer", // 👈 essencial
                }
            );

            // Verifica se retornou algo
            if (!response.data) {
                throw new Error("Nenhum dado recebido da API");
            }

            toast.success("XML da nota gerado com sucesso!");

            // Cria o arquivo .xml
            const blob = new Blob([response.data], { type: "application/xml" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");

            // 🔽 Nome opcional do arquivo para baixar
            link.download = `nota_${item.codnota}.xml`;

            link.href = url;
            link.click();

            // Libera o objeto da memória
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Erro ao tentar baixar XML:", error);
            setError("Erro ao tentar baixar o XML. Tente novamente.");
            toast.error("Ocorreu algum erro! ❌");
        } finally {
            setLoading2(false);
        }
    }

    async function CancelarNfe() {
        try {
            setLoading2(true);
            setError(null);

            if (codempresa === 0) {
                alert('Selecione a filial antes!');
                return; // <-- impede que continue para o POST
            }

            const response = await api.post("/v1/fiscal/cancelarnota", {
                codempresa,
                codnota,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                    responseType: "arraybuffer", // 👈 fundamental
                });

            fetchData();

            toast.success('Nota cancelada com Sucesso!');

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.click();
        } catch (error) {
            console.error('Erro ao cancelar nota:', error);
            setError('Erro ao tentar cancelar nota. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }

    }

    async function InutilizarNfe(item) {
        if (!verificarCorrecao) return;

        try {
            setLoading2(true);
            setError(null);

            if (codempresa === 0) {
                alert('Selecione a filial antes!');
                return; // <-- impede que continue para o POST
            }

            const response = await api.post("/v1/fiscal/inutilizarnota", {
                codempresa,
                codnota,
                correcao
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                    responseType: "arraybuffer", // 👈 fundamental
                });

            fetchData();

            toast.success('Nota inutilizada com Sucesso!');

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.click();
        } catch (error) {
            console.error('Erro ao inutilizar nota:', error);
            setError('Erro ao tentar inutilizar nota. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading2(false);
        }

    }

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <main className="content-container">
                    <PopUp isOpen={isOpen} onClose={handleClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir/cancelar essa nota?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUp>

                    <PopUp2 isOpen={isOpen2} onClose={handleInutilizarClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja inutilizar essa nota?</p>

                        <div className='row'>
                            <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2'>
                                <div className="form-floating">
                                    <input
                                        className="form-control"
                                        type="text"
                                        id="correcao"
                                        value={correcao}
                                        onChange={(e) => setCorrecao(e.target.value)}
                                    />
                                    <label htmlFor="correcao">Correção</label>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleInutilizarConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleInutilizarClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUp2>

                    <div className="container-fluid py-4 d-flex flex-column" style={{ minHeight: '100vh' }}>
                        <Title text="Relação de notas" icon="user" />
                        <Description text="Operação que lista as notas fiscais que foram geradas com os seus status e com opções de ações." />

                        <div className="row mb-3">
                            <div className="col-xl-6 col-lg-5 col-md-5 col-sm-12">
                                <SearchField
                                    value={search}
                                    onChange={setSearch}
                                    placeholder="Buscar nota por: Código ou Cliente"
                                />
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-3 col-sm-12">
                                <DuasDatas
                                    value1={dt1}
                                    onChange1={setdt1}
                                    value2={dt2}
                                    onChange2={setdt2}
                                />
                            </div>
                        </div>

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}

                        {loading2 && <Aguarte />}

                        {/* Corpo principal com flex-grow */}

                        <div className="flex-grow-1 d-flex flex-column">
                            {loading ? (
                                <div className="text-center py-4 flex-grow-1 d-flex align-items-center justify-content-center">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Carregando...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-wrapper flex-grow-1 d-flex flex-column">
                                    <Table
                                        columns={columns}
                                        data={data}
                                        menuActions={(item) => getMenuOptions(item.status)}
                                        columnTextColors={{
                                            status: (value) =>
                                                value === "Nota Transmitida" ? "green" :
                                                    value === "Nota Cancelada" ? "red" :
                                                        "inherit",
                                        }}
                                        showFooter={true}
                                    />
                                </div>

                            )}
                        </div>

                        {/* Pagination no rodapé */}
                        <Pagination
                            currentPage={currentPage}
                            totalPages={pagination.totalPages}
                            onPageChange={setCurrentPage}
                            perPage={perPage}
                            onPerPageChange={handlePerPageChange}
                            total={pagination.total}
                        />

                    </div>
                </main>
            </div>
        </>
    );
};

export default OpeRelacaoNota;